module.exports = __webpack_public_path__ + "static/media/rutabega.25361c24.png";